<script setup lang="ts">
import { FootnoteComponent } from '@dh-io-owpi/shared/src/components/ssr/footnotes';
import { SecondLevel } from '@dh-io-owpi/shared/src/components/SecondLevel';
import { vIntersected } from '@dh-io-owpi/shared/src/directives/v-intersected';
import { formatLabel, useTrackingStore } from '@dh-io-owpi/shared/src/stores/tracking';
import { type TableData } from '../utils/types';
import TechDataTable from './TechDataTable.vue';

const props = defineProps<{
  data: TableData;
  filterText: string;
  open: boolean;
}>();

defineEmits<(event: 'close') => void>();

const { trackOnce } = useTrackingStore();

const footnoteModuleId = `owpi_spa-tech-data-${props.filterText}`;

function intersected() {
  trackOnce({
    category: 'impression',
    name: 'impression',
    action: 'tech_data|modal|technical_data',
    label: `view_full_modal.${formatLabel(props.filterText)}`,
  });
}
</script>
<template>
  <SecondLevel
    class="owpi-all-tech-data-dialog"
    variant="modal"
    disableTeleport
    :title="`${$t('techData.allTechData')} (${filterText})`"
    :open
    @close="$emit('close')"
  >
    <TechDataTable class="_table" :data :footnoteModuleId />
    <div v-intersected="[intersected, { once: true }]" />
    <FootnoteComponent theme="light" :module-id="footnoteModuleId" class="_localFootnotes" />
  </SecondLevel>
</template>

<style lang="scss">
.owpi-all-tech-data-dialog {
  --dialog-max-width: var(--wb-grid-width);
  display: block;
  overflow-y: auto;
  ._table {
    --inline-margin: var(--wb-spacing-s);
  }

  ._localFootnotes {
    display: block;
    margin-inline-start: var(--wb-spacing-s);
    margin-inline-end: var(--wb-spacing-s);
  }
}
</style>
